import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ThemeProvider } from 'styled-components';
import InnerHTML from 'components/InnerHTML';
import Icon from 'components/commons/Icon';

import { SectionTitle } from 'components/SectionTitle';

import { comments } from 'constants/currency';

import {
  WrapperTimeLine,
  Container,
  ItemContainer,
  ItemContent,
  Header,
  Time,
  Currency,
  Description,
  Open,
  Closed,
  PriceWrapper,
  IconWrapper,
  Diff,
  PriceColumn,
} from './styles';

const TimeLine = ({ data, currentCurrency }) => {
  const renderPrice = (price, convertedDiff) => {
    return (
      <PriceColumn>
        {price}
        {convertedDiff > 0 && (
          <PriceWrapper>
            <IconWrapper fall={convertedDiff < 0}>
              <Icon name={convertedDiff < 0 ? 'polygon' : 'growth'} />
              <Diff>{convertedDiff}</Diff>
            </IconWrapper>
          </PriceWrapper>
        )}
      </PriceColumn>
    );
  };
  const renderItem = (index, item) => {
    return (
      <ThemeProvider
        theme={{
          status: item.status,
          isLast: item.status !== comments.ACTIVE,
        }}
        key={`${index}-${item.ask}`}
      >
        <ItemContainer>
          <ItemContent>
            <Header>
              <Time>
                <Icon name="watch" style={{ margin: '-3px 5px 0 0' }} />
                {item.pointDate}
              </Time>

              <Currency>
                {renderPrice(item.bid, item?.trendBid)}
                <span>/</span>
                {renderPrice(item.ask, item?.trendAsk)}
              </Currency>
            </Header>

            {item.status !== comments.ACTIVE && (
              <Closed>
                <FormattedMessage id="timeline.closed" />
              </Closed>
            )}

            {item.status === comments.ACTIVE && item.comment && (
              <Description>
                <InnerHTML html={item.comment} />
              </Description>
            )}

            {item.isFirst ? (
              <Open>
                <FormattedMessage id="timeline.open" />
              </Open>
            ) : null}
          </ItemContent>
        </ItemContainer>
      </ThemeProvider>
    );
  };

  return (
    <WrapperTimeLine>
      <SectionTitle title={`timeLine.title.${currentCurrency}`} />
      <Container>
        {data.map((item, index) => renderItem(index, item))}
      </Container>
    </WrapperTimeLine>
  );
};

TimeLine.defaultProps = {
  data: [],
};

TimeLine.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  currentCurrency: PropTypes.string.isRequired,
};
export default TimeLine;
